import { dataTable } from '@/components/DataTable/locales/data-table.en'
import { socialAnalytics } from '@/features/social-analytics/locales/social-analytics.en'
import { socialPosts } from '@/features/social-posts/locales/social-posts.en'
import { socialAccounts } from '@/features/social-accounts/locales/social-accounts.en'
import { nativeContent } from '@/features/native-content/locales/native-content.en'
import { trendFilter } from '@/features/trend-filter/locales/trend-filter.en'
import { keywordPositioning } from '@/features/keyword-positioning/locales/keyword-positioning.en'
import { contentAmplification } from '@/features/content-amplification/locales/content-amplification.en'
import { keywordGap } from '@/features/keyword-gap/locales/keyword-gap.en'
import { knowledgeBase } from '@/features/knowledge-base/locales/knowledge-base.en'
import { editor } from '@/components/editor/locale/editor.en'
import { selectWithSearch } from '@/components/SelectWithSearch/locales/select-with-search.en'
import { errorBoundary } from '@/components/shared/locales/error-boundary.en'
import { versionUpdate } from '@/components/shared/locales/version-update.en'
import { agent } from '@/features/agent/locales/agent.en'
import { auth } from '@/features/auth/locales/auth.en'
import { bulkGeneration } from '@/features/bulk-generation/locales/bulk-generation.en'
import { contentPlan } from '@/features/content-plan/locales/content-plan.en'
import { contentGenerator, contentOptimization } from '@/features/content-generator/locales/content-generator.en'
import { contentList } from '@/features/content-list/locales/content-list.en'
import { dashboard } from '@/features/dashboard/locales/dashboard.en'
import { data } from '@/features/data/locales/data.en'
import { errors } from '@/features/errors/locales/errors.en'
import { keywordResearch } from '@/features/keyword-research/locales/keyword-research.en'
import { landingPage } from '@/features/landing-page-generator/locales/landing-page.en'
import { brandVoice } from '@/features/brand-voice/locales/brand-voice.en'
import { brandIdentity } from '@/features/brand-identity/locales/brand-identity.en'
import { integrations } from '@/features/integrations/locales/integrations.en'
import onboarding from '@/features/onboarding/locales/onboarding.en'
import { organizationConfiguration, companySettings } from '@/features/organization-configuration/locales/organization-configuration.en'
import { kanban } from '@/features/performance-home/locales/kanban.en'
import { performanceHome } from '@/features/performance-home/locales/performance-home.en'
import { prospectAudit } from '@/features/prospect-audit/locales/prospect-audit.en'
import { seoAudit } from '@/features/seo-audit/locales/seo-audit.en'
import { setupProgress } from '@/features/setup-progress/locales/setup-progress.en'
import { superAdmin } from '@/features/super-admin/locales/super-admin.en'
import { tags } from '@/features/tags/locales/tags.en'
import { deliverables } from '@/features/deliverables/locales/deliverables.en'
import { oauthConsent } from '@/features/oauth-consent/locales/oauth-consent.en'
import { basePages } from './shared/base-pages.en'
import { common } from './shared/common.en'
import { layout } from './shared/layout.en'

export const en = {
  agent,
  auth,
  brandIdentity,
  brandVoice,
  bulkGeneration,
  contentGenerator,
  contentOptimization,
  contentPlan,
  contentList,
  dashboard,
  basePages,
  common,
  data,
  companySettings,
  dataTable,
  editor,
  errorBoundary,
  errors,
  versionUpdate,
  integrations,
  kanban,
  keywordResearch,
  landingPage,
  language: layout.language,
  layout: {
    dashboard: layout.dashboard,
  },
  onboarding,
  organizationConfiguration,
  performanceHome,
  selectWithSearch,
  seoAudit,
  setupProgress,
  sidebar: layout.sidebar,
  sidebarNav: layout.sidebarNav,
  superAdmin,
  tags,
  knowledgeBase,
  prospectAudit,
  deliverables,
  keywordGap,
  contentAmplification,
  keywordPositioning,
  trendFilter,
  oauthConsent,
  nativeContent,
  socialAccounts,
  socialPosts,
  socialAnalytics,
} as const
